// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';

type Props = {
  label: string;
  count?: number;
  active: boolean;
  indented?: boolean;
  onPress: () => void;
};

export default function SidebarItem({ label, count, active, indented = false, onPress }: Props) {
  return (
    <Pressable
      style={[styles.container, indented && styles.indented, active && styles.active]}
      onPress={onPress}
      accessibilityLabel={label}
      accessibilityState={{ selected: active }}
    >
      <View style={styles.bullet} />
      <Text style={[styles.label, active && styles.labelActive]} numberOfLines={1}>
        {label}
      </Text>
      {typeof count === 'number' && (
        <View style={[styles.countBadge, active && styles.countBadgeActive]}>
          <Text style={[styles.countText, active && styles.countTextActive]}>{count}</Text>
        </View>
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 9,
    borderRadius: 10,
    gap: 8,
  },
  indented: {
    paddingLeft: 28,
  },
  active: {
    backgroundColor: appColors.accent.subtleBg,
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: appColors.text.muted,
  },
  label: {
    flex: 1,
    fontSize: 14,
    fontWeight: '600',
    color: appColors.text.secondary,
  },
  labelActive: {
    color: appColors.text.primary,
    fontWeight: '700',
  },
  countBadge: {
    backgroundColor: appColors.surface.muted,
    borderRadius: 8,
    paddingHorizontal: 7,
    paddingVertical: 1,
    minWidth: 22,
    alignItems: 'center',
  },
  countBadgeActive: {
    backgroundColor: appColors.accent.primary,
  },
  countText: {
    fontSize: 11,
    fontWeight: '700',
    color: appColors.text.muted,
  },
  countTextActive: {
    color: '#fff',
  },
});
